import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Container, Typography, Button, CircularProgress } from "@material-ui/core";

import { useWalletConnect } from '../contexts/WalletConnect';
import { TezosToolkit, MichelsonMap } from "@taquito/taquito"
// import { TezBridgeSigner } from '@taquito/tezbridge-signer';
import { InMemorySigner } from '@taquito/signer';
import code from "../utils/code.json"

const Featured = () => {
  const classes = useStyles();
  const { provider } = useWalletConnect();

  const [manager, setManager] = useState('');
  const [threshold, setThreshold] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [result, setResult] = useState('');

  const deploy = async (e) => {
    e.preventDefault()
    setResult('');
    if (!provider) return;
    try {
      setIsLoading(true);
      // provider.setProvider({ signer: new TezBridgeSigner() });
      // const Tezos = await new TezosToolkit('https://granadanet.smartpy.io');
      // Tezos.setProvider({
      //   signer: new InMemorySigner("edsk2tqKjthxv9LYqxZQrCBD9F5AJHEaYtGxL874i9NSjtrZkrrWBd"),
      // });

      const managerArr = manager.split(', ')
      console.log({ managerArr })
      const storage = {
        id_count: 0,
        managers: managerArr,
        pendings: new MichelsonMap(),
        required: 0
      }
      console.log(provider.wallet)
      const originationOp = await provider.wallet.originate({ code: code, storage: storage }).send();
      console.log(`Waiting for confirmation of origination for ${originationOp.opHash}`);
      setResult(originationOp.opHash);
      const contract = await originationOp.contract();
      setResult(contract.address);
      console.log(`Origination completed.`, contract);
      setIsLoading(false);
    } catch (err) {
      console.error(err);
      setIsLoading(false);
    }
  }

  return (
    <section className={classes.details}>
      <Container className={classes.container}>
        <div className={classes.background}>
          <Typography variant="h1" className={classes.title}>
            Deploy Multisig contract
          </Typography>
          <hr className={classes.hrTag} />

          <form onSubmit={deploy} className={classes.form}>
            <div className={classes.inputContainer}>
              <label htmlFor="hash">Manager addresses</label>
              <input
                type="text"
                value={manager}
                onChange={(e) => setManager(e.target.value)}
                required
              />
            </div>
            <div className={classes.inputContainer}>
              <label htmlFor="id">Threshold Value</label>
              <input
                type="number"
                value={threshold}
                onChange={(e) => setThreshold(e.target.value)}
                required
              />
            </div>

            <Button
              type="submit"
              disabled={!isLoading ? false : true}
              className={`${classes.btn} ${classes.filled} ${isLoading && classes.btnWithLoader}`}
            >
              {isLoading ? "Verifying..." : "Deploy"}
              {isLoading && (
                <CircularProgress
                  className={`${classes.loading}`}
                  size={24}
                />
              )}
            </Button>
          </form>
          {result && <p>Waiting for confirmation of origination for <a href={`https://granadanet.tzkt.io/${result}`}>{result}</a></p>}
        </div>
      </Container>
    </section>
  );
};

const useStyles = makeStyles((theme) => ({
  ...theme.overrides.mui,
  ...theme.overrides.formStyle,
  details: {
    position: "relative",
    overflow: "hidden",
  },
  background: {
    width: '100%',
    margin: 'auto',
    height: '100%',
    borderRadius: 25,
    textAlign: 'center',
  },
  title: {
    fontSize: 32,
    fontWeight: 900,
    color: 'black',
    marginTop: 30
  },
  hrTag: {
    height: 5,
    background: '#5f3d7a'
  },
  smallTitle: {
    fontSize: 22,
    marginTop: 20,
    fontWeight: 700,
  },
  nftList: {
    marginTop: 16,
    width: '90%',
    margin: 'auto',
    display: 'grid',
    gridGap: 16,
    gridTemplateColumns: 'repeat(2, 1fr)',
    "@media (max-width:600px)": {
      gridTemplateColumns: 'repeat(1, 1fr)',
    },
  },
  mainImg: {
    width: '100%',
    height: 200,
    margin: 'auto',
    border: '2px solid #1F3C88',
    borderRadius: 10,
  },
}));

export default Featured;
